import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {
  public transform(value: string): string {
        // Remove non-digit characters
    let cleanedPhoneNumber = value?.replace(/\D/g, '');

    // Use regular expression to format the phone number
    return cleanedPhoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
 }
}
